import { applyMiddleware, createStore } from "redux";
import promiseMiddleware from "redux-promise-middleware";
import thunk from "redux-thunk";
import { rootReducer } from "./rootReducer";

const createStoreWithMiddleware = applyMiddleware(thunk, promiseMiddleware())(createStore);

export const initStore = () => {
  return createStoreWithMiddleware(rootReducer, window.devToolsExtension && window.devToolsExtension());
};
